import React from "react";
import ReactTooltip from "react-tooltip";

import colors from "../../style/colors";
import styles from "./Tooltip.module.scss";

interface Props {
  disabled?: boolean;
  fieldName: string;
  value?: string;
  background?: "white" | "blue";
}

export const Tooltip = ({ background, value, disabled, fieldName }: Props) => {
  if (!value) {
    return null;
  }

  return (
    <>
      <div
        className={`${styles.tooltip} ${background === "blue" ? styles["tooltip--blue"] : ""} ${
          disabled ? styles["tooltip--disabled"] : ""
        }`}
        data-tip="React-tooltip"
        data-for={`${fieldName}_info`}
        data-event-off="focusout"
        tabIndex={!disabled ? 0 : undefined}
      >
        <span className={styles.tooltip__label}>Info</span>
        <span className={styles.tooltip__icon}>i</span>
      </div>
      <ReactTooltip
        id={`${fieldName}_info`}
        className={styles.tooltip__tooltip}
        type="dark"
        effect="solid"
        backgroundColor={colors["dela-blue--1_0"]}
        arrowColor={colors["dela-blue--1_0"]}
        disable={disabled}
      >
        {value}
      </ReactTooltip>
    </>
  );
};

export default Tooltip;
